import '../styles/globals.scss'

import type { AppProps } from 'next/app'
import Head from 'next/head'
import { ToastContainer } from 'react-toastify'

/**
 * Main application component that wraps all pages
 * @description This is the root component of the Next.js application that provides global styling and toast notifications
 * @param {AppProps} props - Next.js app props containing Component and pageProps
 * @param {React.ComponentType} props.Component - The page component to render
 * @param {object} props.pageProps - Props to pass to the page component
 * @returns {JSX.Element} The rendered application with global toast container
 */
export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>CheapVeep - $5 VPN Service</title>
      </Head>
      <div id="app" className="min-h-screen">
        <Component {...pageProps} />
        <ToastContainer />
      </div>
    </>
  )
}
